/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs */

const en_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As a token of our gratitude,
we left the choice entirely in your hands.`)
};

const ar_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كعربون امتنانٍ منّا،
تركنا الاختيار بالكامل بين يديك.`)
};

const de_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Zeichen unseres Dankes haben wir die Auswahl ganz in Ihre Hände gelegt.`)
};

const es_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como muestra de nuestro agradecimiento,
dejamos la elección totalmente en sus manos.`)
};

const fr_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En signe de notre gratitude, nous vous avons laissé le choix.`)
};

const it_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come segno della nostra gratitudine, 
abbiamo lasciato la scelta interamente nelle tue mani.`)
};

const ja_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`感謝の気持ちを込めて、
選ぶ楽しみをあなたにお届けします。`)
};

const ko_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`감사의 표시로,
Forest는 전적으로 여러분에게 선택을 맡겼어요.`)
};

const pt_br_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como demonstração de nossa gratidão,
deixamos a escolha inteiramente em suas mãos.`)
};

const ru_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В знак нашей благодарности
мы оставили выбор полностью в ваших руках.`)
};

const th_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพื่อแทนคำขอบคุณจากใจ
เราขอมอบสิทธิ์ในการเลือกไว้ในมือของคุณทั้งหมด`)
};

const tr_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minnettarlığımızın bir göstergesi olarak, 
seçimi tamamen sizin ellerinize bıraktık.`)
};

const zh_cn_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是属于你们的感谢礼
这次，我们把选择权交给你们`)
};

const zh_tw_pro_user_appreciation_letter_bald_cypress_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這是屬於你們的感謝禮
這次，我們把選擇權交給你們`)
};

/**
* | output |
* | --- |
* | "As a token of our gratitude, we left the choice entirely in your hands." |
*
* @param {Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_bald_cypress_body2 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Bald_Cypress_Body2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_bald_cypress_body2(inputs)
	return zh_tw_pro_user_appreciation_letter_bald_cypress_body2(inputs)
});